import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  Typography,
  Chip,
  Container,
  Grid,
  Card,
  Box,
  Button,
} from "@mui/material";
import Map from "../extra/Map";
import { DASHBOARD, PROJECT, CAMERAINFO, SYSTEMINFO } from "../../services/actions";
import {
  BsJournals, BsDatabaseFill, BsCpuFill
} from "react-icons/bs";

const cs = {
  width: 40,
  height: "100%",
  background: "#227d52",
  borderRadius: 100,
  position: "relative",
};
const csz = {
  ...cs,
  backgroundImage:
    "repeating-linear-gradient(135deg, gray 0px, gray 2px, white 0px, white 4px)",
};

const covertSStoHHMM = (image_gap_seconds) => {
  const hours = Math.floor(image_gap_seconds / 3600);
  const minutes = Math.floor((image_gap_seconds % 3600) / 60);
  const hhmm = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  return hhmm  // Outputs: 00:06
}
function Info({ data, onStatusChange }) {
  const [online, setOnline] = useState("Offline");

  useEffect(() => {
    let img;

    if (data?.camera_type === "Timelapse") {
      const status = data?.is_active ? "Online" : "Offline";
      setOnline(status);
      onStatusChange?.(data.id, status); // send status back
    } else if (data?.url) {
      img = new Image();
      img.src = data.url;

      img.onload = () => {
        setOnline("Online");
        onStatusChange?.(data.id, "Online");
      };
      img.onerror = () => {
        setOnline("Offline");
        onStatusChange?.(data.id, "Offline");
      };
    }

    return () => {
      if (img) {
        img.onload = null;
        img.onerror = null;
      }
    };
  }, [data]);

  return (
    <Card
      sx={{
        p: 3,
        borderRadius: 8,
        boxShadow: 0,
      }}
    >
      <Box display={'flex'}>
        <Box sx={{ width: 1 }}>
          <Typography fontWeight={800} fontSize={13}>{data.name}</Typography>
          <Typography fontWeight={700} fontSize={12}>{data.project}</Typography>
          <Typography fontWeight={700} fontSize={11}>{data.company}</Typography>
          <Typography fontSize={12} mt={2}>Last Image Received {covertSStoHHMM(data?.image_gap_seconds)} Minutes ago</Typography>
          <Typography fontSize={11}>{data?.camera_type}</Typography>
        </Box>
        <Box>
          <Typography
            className="toggle-status"
            sx={{
              p: 0.5,
              borderRadius: 2,
              color: 'white',
              background: online === 'Offline' ? '#c91d1d' : 'green',
              textAlign: 'center'
            }}
            fontSize={10}
            mb={2}
          >
            {online}
          </Typography>

          {data?.camera_type === "Timelapse" ? (
            <img src={data?.latest_image_path} height="40" style={{ borderRadius: 4 }} alt="" />
          ) : (
            <img src={data.url} height="40" style={{ borderRadius: 4 }} alt="" />
          )}
        </Box>
      </Box>
    </Card>
  );
}


export default function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let user = useSelector((state) => state?.loginState?.auth)
  const cameraInfoState = useSelector((state) => state.camerainfoState)
  const systemInfoState = useSelector((state) => state.systeminfoState)
  const [statusMap, setStatusMap] = useState({});
  let onlineCount = 0;
  let offlineCount = 0;

  // const handleStatusUpdate = (id, status) => {
  //   if (status === "Online") onlineCount++;
  //   else if (status === "Offline") offlineCount++;
  //   setStatusMap(prev => ({ ...prev, [id]: status, onlineCount, offlineCount }));
  // };
  // useEffect(() => {
  //   dispatch({ type: `${CAMERAINFO}_GET`, payload: 0 });
  //   dispatch({ type: `${SYSTEMINFO}_GET`, payload: 0 });
  // }, [dispatch]);


  // const getLocations = (datas) => {
  //   let ds = datas.map((d) => { return { latlng: d.camera_location.split(","), desc: d.camera_name } })
  //   return ds.filter((d) => d.latlng.length >= 2)
  // }

  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12}>
          <Typography sx={{ pt: 2 }} fontSize={11} fontWeight={600}>
            G'day, {user.first_name} —{" "}
            <Chip size="small" label={user.main_role} />
          </Typography>
        </Grid>
      </Grid>


      <Grid container spacing={2} mb={2}>
        <Grid size={{ xs: 12, md: 3 }}>
          <Card
            sx={{
              p: 3,
              borderRadius: 8,
              boxShadow: 0,
            }}
            onClick={() => {
              navigate("/camera-report/")
            }}
          >
            <Box>
              <BsJournals fontSize={60} />
            </Box>
            <Typography sx={{ mt: 2 }}>Camera Information</Typography>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          <Card
            sx={{
              p: 3,
              borderRadius: 8,
              boxShadow: 0,
            }}
            onClick={() => {
              navigate("/system-report/")
            }}
          >
            <Box>
              <BsCpuFill fontSize={60} />
            </Box>
            <Typography sx={{ mt: 2 }}>System Information</Typography>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          <Card
            sx={{
              p: 3,
              borderRadius: 8,
              boxShadow: 0,
            }}
            onClick={() => {
              navigate("/backup-report/")
            }}
          >
            <Box>
              <BsDatabaseFill fontSize={60} />
            </Box>
            <Typography sx={{ mt: 2 }}>Backup Information</Typography>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
